import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { AppRoutes } from '@/constants/appRoutes'

interface InsufficientCreditsDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export const InsufficientCreditsDialog = ({
  open,
  onOpenChange,
}: InsufficientCreditsDialogProps) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="flex w-6/12 flex-col max-md:w-11/12">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-textNormal text-[32px] font-medium tracking-wide max-md:text-left max-md:text-[30px]">
            {t('dashboard.home.insufficientCredits')}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-textNormal text-base font-medium tracking-tight max-md:text-left">
            {t('dashboard.home.insufficientCreditsText')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex flex-col gap-3 lg:flex-row lg:gap-0">
          <Button
            type="button"
            variant="secondary"
            onClick={() => onOpenChange(false)}
          >
            {t('dashboard.home.cancel')}
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => navigate(AppRoutes.support)}
          >
            {t('dashboard.home.contactSales')}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
